const AUTH_KEY = 'auth-token';

export const storeJwt = (jwtToken: string) => {
  localStorage.setItem(AUTH_KEY, jwtToken);
};

export const removeJwt = () => localStorage.removeItem(AUTH_KEY);

export const getJwt = () => localStorage.getItem(AUTH_KEY);
